import { DtoBase } from 'UvExplorerServer.Dtos.TS';
import { IfEntry } from 'DiscoveryEngine.TS/InfoSets';
import { SnmpConstants } from '../../DiscoveryEngine.TS/Core/SnmpConstants';
import { ValueEncoder } from '../../DiscoveryEngine.TS/Utils';


export enum PortStateType {
	None,
	PoeState,
	AdminStatus,
	AccessVlan,
	Alias,
	ConnectedDevices,
}


export class PortStateDto extends DtoBase {

	public DeviceGuid: string;
	public IfIndex: number;
	public PoeAdminEnable: number;
	public AdminStatus: number;
	public BridgePortIndex: number;
	public VlanIndex: number;
	public VoiceVlanIndex: number;
	public Alias: string;

	constructor() {
		super();

		this.DeviceGuid = "";
		this.IfIndex = IfEntry.INVALID_IFINDEX;
		this.PoeAdminEnable = SnmpConstants.pethPsePortAdminEnable_unknown;
		this.AdminStatus = SnmpConstants.ifStatus_unknown;
		this.BridgePortIndex = -1;
		this.VlanIndex = -1;
		this.VoiceVlanIndex = -1;
		this.Alias = null;
	}

	public get HasDeviceGuid(): boolean {
		return !!this.DeviceGuid;
	}

	public get HasIfIndex(): boolean {
		return (this.IfIndex != IfEntry.INVALID_IFINDEX);
	}

	public get HasPoeAdminEnable(): boolean {
		return (this.PoeAdminEnable != SnmpConstants.pethPsePortAdminEnable_unknown);
	}

	public get HasAdminStatus(): boolean {
		return (this.AdminStatus != SnmpConstants.ifStatus_unknown);
	}

	public get HasBridgePortIndex(): boolean {
		return (this.BridgePortIndex >= 0);
	}

	public get HasVlanIndex(): boolean {
		return (this.VlanIndex >= 0);
	}

	public get HasVoiceVlanIndex(): boolean {
		return (this.VoiceVlanIndex > 0);
	}

	public get HasAlias(): boolean {
		return (this.Alias != null);
    }

	public override Write(obj: any, context: any): void {

		obj.port_state = {};
		obj = obj.port_state;

		if (this.HasDeviceGuid) {
			obj.device_guid = this.DeviceGuid;
		}
		if (this.HasIfIndex) {
			obj.if_index = ValueEncoder.EncodeInteger(this.IfIndex);
		}
		if (this.HasPoeAdminEnable) {
			obj.poe_admin_en = ValueEncoder.EncodeInteger(this.PoeAdminEnable);
		}
		if (this.HasAdminStatus) {
			obj.admin_status = ValueEncoder.EncodeInteger(this.AdminStatus);
		}
		if (this.HasBridgePortIndex) {
			obj.bridge_port_index = ValueEncoder.EncodeInteger(this.BridgePortIndex);
		}
		if (this.HasVlanIndex) {
			obj.vlan_index = ValueEncoder.EncodeInteger(this.VlanIndex);
		}
		if (this.HasVoiceVlanIndex) {
			obj.voice_vlan_index = ValueEncoder.EncodeInteger(this.VoiceVlanIndex);
		}
		if (this.HasAlias) {
			obj.alias = this.Alias;
        }
	}

	public override Read(obj: any, context: any): void {

		if (!obj.port_state)
			throw new Error();
		obj = obj.port_state;

		if (obj.device_guid !== undefined) {
			this.DeviceGuid = obj.device_guid;
		}
		if (obj.if_index !== undefined) {
			this.IfIndex = ValueEncoder.DecodeInteger(obj.if_index);
		}
		if (obj.poe_admin_en !== undefined) {
			this.PoeAdminEnable = ValueEncoder.DecodeInteger(obj.poe_state);
		}
		if (obj.admin_status !== undefined) {
			this.AdminStatus = ValueEncoder.DecodeInteger(obj.admin_status);
		}
		if (obj.bridge_port_index !== undefined) {
			this.BridgePortIndex = ValueEncoder.DecodeInteger(obj.bridge_port_index);
		}
		if (obj.vlan_index !== undefined) {
			this.VlanIndex = ValueEncoder.DecodeInteger(obj.vlan_index);
		}
		if (obj.voice_vlan_index !== undefined) {
			this.VoiceVlanIndex = ValueEncoder.DecodeInteger(obj.voice_vlan_index);
		}
		if (obj.alias !== undefined) {
			this.Alias = obj.alias;
        }
	}
}
